module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.4 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:mask-z-index")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:display-format #2023")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:align-items")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support method:getFullValue #2022")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:mask-z-index")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/previewer.html"
    }
  }, [_vm._v("Previewer")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] automatically update view if one slide is deleted")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:mask-z-index")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/close-dialogs.html"
    }
  }, [_vm._v("CloseDialogs")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new plugin for closing all dialogs #2025")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b9287408", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-b9287408"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.4-128.vue
// module id = 2427
// module chunks = 257